import { hash, splitSettledPromises } from '../utils';
/**
 * Обработчик для ремоут компонентов, отвечает за их добавление и загрузку
 */
export class BaseRemoteWidgetHandler {
    constructor(serviceDiscoveryClient, headers, mfServer, transaction) {
        this.serviceDiscoveryClient = serviceDiscoveryClient;
        this.headers = headers;
        this.mfServer = mfServer;
        this.transaction = transaction;
        this.queue = new Map();
        this._store = [];
        //
    }
    get bundles() {
        return this._store;
    }
    getWidgetHash(widgetData) {
        return hash(widgetData);
    }
    add(widgetData) {
        const widgetHash = this.getWidgetHash(widgetData);
        if (this.queue.has(widgetHash)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this.queue.get(widgetHash);
        }
        const promise = this.loadWidget(widgetData, widgetHash);
        this.queue.set(widgetHash, promise);
        promise.then(data => {
            if (data) {
                this._store.push({
                    ...data,
                    id: widgetData.id,
                });
            }
        });
        return promise;
    }
    async waitAll() {
        let data = await Promise.allSettled(this.queue.values());
        this.queue.clear();
        return splitSettledPromises(data);
    }
    loadState(widget) {
        return Promise.resolve(undefined);
    }
}
